import React from "react";

const Footer = (props) => {
    return <div className='footer'><p><span>Developer: </span>{props.developerName}</p></div>
}

export default Footer